/**
 * Opciones de Tippy para los [data-bs-toggle="tooltip"] (app.js).
 *
 * Tippy v6 NO acepta `placement` como función (eso es de Bootstrap): Popper hace
 * `placement.split('-')` y truena con "e.split is not a function" en cada hover, como
 * promesa rechazada que nadie atrapa — un evento de Sentry por página y el tooltip sin
 * salir (2026-10-02, Emitidos, Recibidos, Recibo de pago, Plantillas, Productos). Aquí el
 * placement es una cadena y cada elemento toma el suyo de data-bs-placement al crearse.
 *
 * Varias vistas además inician el tooltip de Bootstrap sobre los mismos elementos
 * ($().tooltip() o new bootstrap.Tooltip); hoy el usuario ve ese, porque el de Tippy
 * nunca llegaba a salir. Para no pintar dos, Tippy se hace a un lado cuando el elemento
 * ya tiene tooltip de Bootstrap.
 *
 * @param {() => any} getBootstrap  devuelve window.bootstrap en el momento del hover
 */
export function opcionesTooltipBs(getBootstrap) {
  return {
    content: function (el) {
      return el.getAttribute('data-bs-original-title')
          || el.getAttribute('title')
          || el.getAttribute('data-original-title')
          || '';
    },
    placement: 'top',
    arrow: true,
    delay: [150, 0],
    theme: 'fd',
    onCreate: function (instance) {
      var el = instance.reference;
      var p = el.getAttribute('data-bs-placement') || el.getAttribute('data-placement');
      if (p) instance.setProps({ placement: p });
      // Como hace Bootstrap al iniciar (_fixTitle): el `title` pasa a
      // data-bs-original-title para que el navegador no pinte además su tooltip
      // nativo, y si el elemento no tiene nombre accesible lo conserva en aria-label.
      var t = el.getAttribute('title');
      if (t) {
        if (!el.getAttribute('data-bs-original-title')) el.setAttribute('data-bs-original-title', t);
        if (!el.getAttribute('aria-label') && !String(el.textContent || '').trim()) el.setAttribute('aria-label', t);
        el.removeAttribute('title');
      }
    },
    onShow: function (instance) {
      if (!instance.props.content) return false;
      var bs = getBootstrap();
      if (bs && bs.Tooltip && bs.Tooltip.getInstance(instance.reference)) return false;
    }
  };
}
